// extracted by mini-css-extract-plugin
export var headlineArrow = "Q4RUD";
export var headlineButton = "_4IlA-";